import { render } from "./PainelRelatorioVendasBI.vue?vue&type=template&id=3bcf317f&scoped=true&ts=true"
import script from "./PainelRelatorioVendasBI.vue?vue&type=script&lang=ts"
export * from "./PainelRelatorioVendasBI.vue?vue&type=script&lang=ts"

import "./PainelRelatorioVendasBI.vue?vue&type=style&index=0&id=3bcf317f&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcf317f"]])

export default __exports__